module.exports = __webpack_public_path__ + "static/media/secondareaproduct3.3f095814.jpg";